document.addEventListener('DOMContentLoaded', function () {
  var mapContainer = document.getElementById('map');
  if (!mapContainer) return;
  if (typeof mapboxgl === 'undefined') return;

  var mapSection = document.getElementById('wineries-map-section');
  var mapWrap = document.querySelector('.wineries-map-wrap');
  if (!mapSection || !mapWrap) return;

  var lastChapterName = 'kisvin-gardens';

  function setBehindFooter(isBehind) {
    if (isBehind) mapContainer.classList.add('behind-footer');
    else mapContainer.classList.remove('behind-footer');
  }

  mapboxgl.accessToken =
    'pk.eyJ1IjoiZ3VuamFucmFpayIsImEiOiJja2Z2N3dkcmkwODk4MnFwN3pnd3k3dzIyIn0.HZp4zYL_txhS0Buvv0NmAg';

  var map = new mapboxgl.Map({
    container: 'map',
    style: 'mapbox://styles/mapbox/streets-v11',
    center: [138.7241439, 35.6634402],
    zoom: 5.5,
    bearing: 60,
    pitch: 30
  });

  map.addControl(new mapboxgl.NavigationControl());

  var chapters = {
    home: { center: [138.7241439, 35.6634402], zoom: 5.5, bearing: 30, pitch: 30 },
    baker: { center: [138.7241439, 35.6634402], zoom: 14, bearing: 30, pitch: 30 },
    aldgate: { bearing: 27, center: [138.7213722, 35.6591823], zoom: 14, pitch: 0 },
    'london-bridge': { bearing: 27, center: [138.7134048, 35.6560613], zoom: 14, speed: 0.6, pitch: 0 },
    'kisvin-gardens': { bearing: 27, center: [138.7320338, 35.7130304], zoom: 14, speed: 0.6, pitch: 0 }
  };

  var geojson = {
    type: 'FeatureCollection',
    features: [
      { type: 'Feature', geometry: { type: 'Point', coordinates: [138.7241439, 35.6634402], popup: 'KURAMBON WINERY' } },
      { type: 'Feature', geometry: { type: 'Point', coordinates: [138.7213722, 35.6591823], popup: 'CHATEAU MERCIAN' } },
      { type: 'Feature', geometry: { type: 'Point', coordinates: [138.7134048, 35.6560613], popup: 'KATSUNUMA WINERY' } },
      { type: 'Feature', geometry: { type: 'Point', coordinates: [138.7320338, 35.7130304], popup: 'KISVIN WINERY' } }
    ]
  };

  // Auto-open popup mapping
  var chapterToPopupKey = {
    baker: 'KURAMBON WINERY',
    aldgate: 'CHATEAU MERCIAN',
    'london-bridge': 'KATSUNUMA WINERY',
    'kisvin-gardens': 'KISVIN WINERY'
  };

  var markers = {};

  geojson.features.forEach(function (feature) {
    var el = document.createElement('div');
    el.className = 'marker';

    var popup = new mapboxgl.Popup({
      offset: 25,
      closeButton: false,
      closeOnClick: false
    }).setText(feature.geometry.popup);

    var marker = new mapboxgl.Marker(el)
      .setLngLat(feature.geometry.coordinates)
      .setPopup(popup)
      .addTo(map);

    markers[feature.geometry.popup] = { marker: marker, popup: popup };
  });

  function closeAllPopups() {
    Object.keys(markers).forEach(function (k) {
      markers[k].popup.remove();
    });
  }

  function openPopupForChapter(chapterName) {
    var key = chapterToPopupKey[chapterName];
    if (!key || !markers[key]) return;
    closeAllPopups();
    markers[key].popup.addTo(map);
  }

  var activeChapterName = 'home';

  function setActiveChapter(chapterName) {
    if (chapterName === activeChapterName) return;
    if (!chapters[chapterName]) return;

    map.easeTo(Object.assign({}, chapters[chapterName], { duration: 900 }));

    var newActive = document.getElementById(chapterName);
    var oldActive = document.getElementById(activeChapterName);
    if (newActive) newActive.classList.add('active');
    if (oldActive) oldActive.classList.remove('active');

    activeChapterName = chapterName;
    openPopupForChapter(chapterName);
  }

  function isElementOnScreen(id) {
    var el = document.getElementById(id);
    if (!el) return false;

    var rect = el.getBoundingClientRect();
    var triggerY = 350; // your current tuning
    return rect.top <= triggerY && rect.bottom > triggerY;
  }

  function clearFixedInline() {
    mapContainer.style.left = '';
    mapContainer.style.width = '';
  }

  function lockFixedToRightColumn() {
    var wrapRect = mapWrap.getBoundingClientRect();
    if (wrapRect.width <= 50) return;
    mapContainer.style.left = wrapRect.left + 'px';
    mapContainer.style.width = wrapRect.width + 'px';
  }

  function updateSticky() {
    if (window.matchMedia('(max-width: 768px)').matches) {
      mapContainer.classList.remove('change');
      mapContainer.classList.remove('at-bottom');
      setBehindFooter(false);
      clearFixedInline();
      window.requestAnimationFrame(function () { map.resize(); });
      return;
    }

    if (mapWrap.offsetWidth <= 50) return;

    var sectionRect = mapSection.getBoundingClientRect();
    var sectionTop = sectionRect.top + window.scrollY;

    // ✅ use wrapper bottom
    var wrapRect = mapWrap.getBoundingClientRect();
    var wrapperBottom = (wrapRect.top + window.scrollY) + wrapRect.height;

    var topOffset = 100;
    var startStick = sectionTop + 190;
    var bottomBuffer = 40;

    var mapHeight = mapContainer.getBoundingClientRect().height || 800;
    var stopStick = wrapperBottom - mapHeight - topOffset - bottomBuffer;
    if (stopStick <= startStick + 10) stopStick = startStick + 11;

    var inStickyRange = window.scrollY >= startStick && window.scrollY < stopStick;
    var pastStop = window.scrollY >= stopStick;

    // ✅ only last chapter goes "behind footer"
    setBehindFooter(pastStop && activeChapterName === lastChapterName);

    if (inStickyRange) {
      mapContainer.classList.add('change');
      mapContainer.classList.remove('at-bottom');
      lockFixedToRightColumn();
    } else if (pastStop) {
      // ✅ ALWAYS pin at bottom (no bounce)
      mapContainer.classList.remove('change');
      mapContainer.classList.add('at-bottom');
      clearFixedInline();
    } else {
      mapContainer.classList.remove('change');
      mapContainer.classList.remove('at-bottom');
      setBehindFooter(false);
      clearFixedInline();
    }

    window.requestAnimationFrame(function () { map.resize(); });
  }

  function onScroll() {
    var chapterNames = Object.keys(chapters);
    for (var i = 0; i < chapterNames.length; i++) {
      var chapterName = chapterNames[i];
      if (isElementOnScreen(chapterName)) {
        setActiveChapter(chapterName);
        break;
      }
    }
    updateSticky();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () {
    if (mapContainer.classList.contains('change')) lockFixedToRightColumn();
    updateSticky();
  });

  map.on('load', function () {
    onScroll();
    updateSticky();
  });

  updateSticky();
});
